import { render, staticRenderFns } from "./RecognitionFeed.vue?vue&type=template&id=108ab636&scoped=true&"
import script from "./RecognitionFeed.vue?vue&type=script&lang=js&"
export * from "./RecognitionFeed.vue?vue&type=script&lang=js&"
import style0 from "./RecognitionFeed.vue?vue&type=style&index=0&id=108ab636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108ab636",
  null
  
)

export default component.exports